import React from 'react'
import PropTypes from 'prop-types'
import { decodeHtml } from '../../utils'

const CourseNavItem = React.forwardRef((props, ref) => {
  const textColor = hasHref => {
    if (!hasHref) {
      return 'full-link'
    } else {
      return null
    }
  }

  const displayChevron = chevronOpen => {
    if (typeof chevronOpen === 'undefined') {
      return null
    }
    if (chevronOpen) {
      return <i className="fal fa-chevron-up mt-2 ml-4 mr-4" aria-hidden />
    } else if (!chevronOpen) {
      return <i className="fal fa-chevron-down mt-2 ml-4 mr-4" aria-hidden />
    }
  }

  const displayLock = isLocked => {
    if (isLocked) {
      return <i className="far fa-fw mr-2 fa-lock-alt icon_color_orange" />
    }
  }

  return (
    <React.Fragment>
      <li
        className="ReaderNavItemBlue CourseNavMenuItem dropdown-item"
        role="menuitem"
        ref={ref}
        tabIndex="0"
      >
        <a
          className={`custom-padding-left-${
            props.paddingLeft
          } d-block ${textColor(
            typeof props.href === 'undefined'
          )} truncate-link-text`}
          onClick={props.onClick}
          onKeyDown={props.handleKeyDown}
          href={typeof props.href !== 'undefined' ? props.href : '#'}
          role="menuitem"
        >
          {displayLock(props.isLocked)}
          {displayChevron(props.chevronOpen)}
          {typeof props.handleKeyDown === 'undefined' && (
            <i
              className="fa-fw fal fa-long-arrow-right primary mt-2 mx-3"
              aria-hidden
            />
          )}
          {decodeHtml(props.itemTitle)}
        </a>
      </li>
    </React.Fragment>
  )
})

CourseNavItem.displayName = 'CourseNavItem'

CourseNavItem.propTypes = {
  itemTitle: PropTypes.string,
  isActive: PropTypes.bool,
  paddingLeft: PropTypes.string,
  handleKeyDown: PropTypes.func,
  onClick: PropTypes.func,
  chevronOpen: PropTypes.bool,
  demo: PropTypes.bool,
  href: PropTypes.string,
  isLocked: PropTypes.bool,
}

export default CourseNavItem
